// extracted by mini-css-extract-plugin
export var addToCartButton = "_r8-b";
export var arrowButtonContainer = "_r8-9";
export var arrowButtonIcon = "_r8-a";
export var carouselArrowButton = "_r8-6";
export var carouselElementContainer = "_r8-1";
export var left = "_r8-7";
export var productDisplayCarouselContainer = "_r8-0";
export var productTileContainer = "_r8-2";
export var productTileImage = "_r8-4";
export var productTileImageContainer = "_r8-3";
export var productTileTitle = "_r8-5";
export var right = "_r8-8";
export var sliderOverflow = "_r8-c";